import React, { useState } from 'react';
import '../styles/Hero.css';

const Hero = () => {
  const [bgChanged, setBgChanged] = useState(false);

  const handleClick = () => {
    setBgChanged(!bgChanged);
    //document.getElementById('projects').scrollIntoView({ behavior: 'smooth' });
  };

  const heroClass = bgChanged ? 'hero hero-alt' : 'hero';

  return (
    <section className={heroClass}>
      <div className="hero-overlay">
        <h1>Welcome to Will's Website</h1>
        <p>Created with React and a Canon EOS</p>
        <button className="hero-btn" onClick={handleClick}>Press</button>
      </div>
    </section>
  );
};

export default Hero;
